<script setup>
import { computed } from 'vue';
import ColorPicker from 'dashboard/components-next/colorpicker/ColorPicker.vue';
import PropertySection from './PropertySection.vue';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const localStyle = computed(() => {
  return (
    props.widget.style || {
      backgroundType: 'white',
      backgroundColor: '#FFFFFF',
      textColor: '#1F2937',
      textSecondaryColor: '#6B7280',
      primaryColor: '#FF8C42',
      borderColor: '#E5E7EB',
    }
  );
});

const updateStyle = (key, value) => {
  const newWidget = JSON.parse(JSON.stringify(props.widget));
  if (!newWidget.style) newWidget.style = {};
  newWidget.style[key] = value;
  emit('update', newWidget);
};
</script>

<template>
  <div class="space-y-6">
    <PropertySection title="Couleurs" icon="i-lucide-palette">
      <div class="grid grid-cols-2 gap-4">
        <div class="space-y-1.5">
          <label
            class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
            >Fond</label>
          <ColorPicker
            :model-value="localStyle.backgroundColor"
            @update:model-value="updateStyle('backgroundColor', $event)"
          />
        </div>
        <div class="space-y-1.5">
          <label
            class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
            >Bordure</label>
          <ColorPicker
            :model-value="localStyle.borderColor"
            @update:model-value="updateStyle('borderColor', $event)"
          />
        </div>
        <div class="space-y-1.5">
          <label
            class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
            >Texte Principal</label>
          <ColorPicker
            :model-value="localStyle.textColor"
            @update:model-value="updateStyle('textColor', $event)"
          />
        </div>
        <div class="space-y-1.5">
          <label
            class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
            >Texte Secondaire</label>
          <ColorPicker
            :model-value="localStyle.textSecondaryColor"
            @update:model-value="updateStyle('textSecondaryColor', $event)"
          />
        </div>
        <div class="space-y-1.5">
          <label
            class="text-xs font-semibold text-n-slate-11 uppercase tracking-wider"
            >Couleur Accent</label>
          <ColorPicker
            :model-value="localStyle.primaryColor"
            @update:model-value="updateStyle('primaryColor', $event)"
          />
        </div>
      </div>
    </PropertySection>
  </div>
</template>
